import { useEffect } from 'react'
import { Spinner } from '@epam/loveship'
import { amplTrack } from '@stlm/common-ui/lib'
import { ReviewTypeEnum } from '../../../../constants/enums'
import { LocationResponse } from '../../../../constants/types'
import { useActions } from '../../../../hooks/redux/actions'
import { useAppSelector } from '../../../../hooks/redux/redux'
import { useSideBarControlls } from '../../../../hooks/useSideBarControlls'
import {
  useGetLocationMutation,
  useGetLocationReviewQuery,
} from '../../../../store'
import { LocationDetails } from '../LocationDetails/LocationDetails'
import { Reviews } from '../Reviews/Reviews'

type LocationInfoProps = {
  selectedLocation: LocationResponse
}

export const LocationInfo = ({ selectedLocation }: LocationInfoProps) => {
  const { setSelectedLocation, setSelectedLocationId } = useActions()
  const [refetchLocations] = useGetLocationMutation()
  const {
    data: reviews,
    refetch: refetchReviews,
    isLoading,
  } = useGetLocationReviewQuery(selectedLocation.id)
  const { closeSideBar } = useSideBarControlls()
  const { isSideBarCloseInitiated } = useAppSelector((state) => state.app)

  const refetch = (id: number) => {
    refetchLocations({ locationId: id })
      .unwrap()
      .then((value) => {
        if (value?.length > 0) {
          setSelectedLocation(value[0])
          setSelectedLocationId(value[0].id)
        }
      })
  }

  useEffect(() => {
    if (isSideBarCloseInitiated) closeSideBar()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSideBarCloseInitiated])

  useEffect(() => {
    amplTrack({
      name: 'map_place_view',
      place_type: selectedLocation.type,
      place_name: selectedLocation.name,
      place_id: selectedLocation.id,
    })
  }, [selectedLocation])

  return (
    <>
      <LocationDetails
        locationName={selectedLocation.name}
        locationType={selectedLocation.type}
      />
      {isLoading ? (
        <Spinner />
      ) : (
        <Reviews
          itemId={selectedLocation.id}
          itemRating={selectedLocation.rating}
          itemName={selectedLocation.name}
          itemType={selectedLocation.type}
          type={ReviewTypeEnum.location}
          refetchItems={refetch}
          reviews={reviews}
          refetchReviews={() => refetchReviews()}
        />
      )}
    </>
  )
}
